import bingoModalEdit from './index.vue';
export default bingoModalEdit;



// WEBPACK FOOTER //
// ./src/components/bingo-modal-edit/index.js